<template>
  <div class="row password-change">
    <v-container fill-height fluid grid-list-xl>
      <v-layout justify-center
                wrap>

        <v-flex xs12 md10 lg8>
          <material-card :color="getTitleColorStore"
                         :title="$t('menu_presence_exam_results')">
            <ProgressBar :loading="loading" color="deep-purple accent-4" />

            <template>
              <v-container grid-list-md>
                <v-layout row wrap>
                  <v-flex xs12 md6>
                    <SelectEducation ref="myselect" :PopisUsluga="uslugeZaEVListu" :odabir="setOdabranaUsluga"></SelectEducation>
                  </v-flex>
                  <v-flex xs12 md6 class="text-right">
                    <v-btn target="_blank" class="red" small :href="myQTestLink">
                    <span class="white--text">
                      <v-icon>mdi-format-list-checks</v-icon>
                      {{ $t('ev_lista.my_q_test_results_link_title') }}
                    </span>
                    </v-btn>
                  </v-flex>
                  <v-flex xs-12 md12 class="text-right">
                    <v-icon class="green--text ">mdi-check-circle</v-icon>
                    {{$t('ev_lista.exam_result._1')}}

                    <v-icon class="red--text pl-4">mdi-close-circle</v-icon>
                    {{$t('ev_lista.exam_result._2')}}

                    <v-icon class="orange--text pl-4">mdi-alert</v-icon>
                    {{$t('ev_lista.exam_result._3')}}

                    <v-icon class="blue--text pl-4">mdi-clock</v-icon>
                    {{$t('ev_lista.exam_result._4')}}

                  </v-flex>
                  <v-flex xs12>
                    <EvidencijskaLista :EvLista="EvLista"></EvidencijskaLista>
                  </v-flex>
                </v-layout>
              </v-container>
            </template>

          </material-card>
        </v-flex>

      </v-layout>
    </v-container>
  </div>
</template>

<script>
  import { mapState, mapGetters } from 'vuex';
  import SelectEducation from './presence_exam_results/SelectEducation.vue';
  import EvidencijskaLista from './presence_exam_results/EvidencijskaLista.vue';


  export default {
    name: 'PresenceExamResults',
    computed: {
      ...mapState('app', ['currentUser']),
      ...mapGetters({ getTitleColorStore: 'app/getTitleColor' }),
      loading() {
        return this.loadingUsluge || this.loadingListu;
      }
    },

    methods: {
      async getUslugeZaEvListu() {
        this.loadingUsluge = true;
        var result = await this.$fetchDataPromise('/api/Exam/GetUslugeZaEVListu', null).catch(x => { this.loadingUsluge = false; this.$displayError(x) });

        for (var i = 0; i < result.length; i++) {
          var el = result[i];
          el.rbr = i;
        }

        this.uslugeZaEVListu = result;
        this.$refs.myselect.odabranaUsluga = result[0];
        this.setOdabranaUsluga(result[0]);
        this.loadingUsluge = false;
      },

      async setOdabranaUsluga(usluga) {
        if (usluga) {
          this.loadingListu = true;
          var result = await this.$fetchDataPromise('/api/Exam/GetEvidencijskuListu', usluga).catch(x => { this.loadingListu = false; this.$displayError(x) });
          this.EvLista = result;
          this.loadingListu = false;
        }
      },

      async generateMyQTestLink() {
        var data = { OIB: this.currentUser.OIB };
        var result = await this.$fetchDataPromise('/api/Base/EncryptText', data, 'POST', false);

        var queryString = "http://myqtest.algebra.hr/newClient/statExternal.aspx" + result;
        this.myQTestLink = queryString;
        return queryString;
      },

    },



    mounted() {
      this.getUslugeZaEvListu()
      this.generateMyQTestLink();
    },

    data: function () {
      return {
        loadingListu: false,
        loadingUsluge: false,
        uslugeZaEVListu: [],
        EvLista: [],
        myQTestLink: ''
      }
    },

    components: {
      SelectEducation, EvidencijskaLista
    }
  }
</script>

<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// VueSrc/Exams/PresenceAndExamResults.vue